/**
 * Vue Router Configuration
 */

import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/ensembles",
      name: "ensembles",
      component: () => import("@/views/EnsemblesView.vue"),
    },
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/AboutView.vue"),
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("@/views/SettingsView.vue"),
    },
    {
      path: "/map",
      name: "map",
      component: () => import("@/views/MapView.vue"),
    },
  ],
});

if (import.meta.env.DEV)
  router.addRoute({
    path: "/radar-profile",
    name: "radar-profile",
    component: () => import("@/components/dev/RadarProfile.vue"),
  });

export default router;
